export function parsePictureSizes(pictureSizes) {
    const resultArray = [];
    for (const [key, value] of Object.entries(pictureSizes)) {
        if (key !== 'default') {
            const pictureSize = parseInt(key.replace('min-', ''));
            resultArray.push(`(min-width: ${pictureSize}px) ${value}`);
        }
    }
    resultArray.push(pictureSizes.default);
    return resultArray.join(', ');
}
